import type { ParsedUrlQuery } from '@confluence/route-manager-utils';

export const whiteboardSpotFromParams = function whiteboardSpotFromParams(
	params: ParsedUrlQuery,
	name: 'canvas-server' | 'canvas-relay',
): number | undefined {
	const rawSpot = params[name];

	if (!rawSpot || Array.isArray(rawSpot)) {
		return;
	}

	const maybeSpot = parseInt(rawSpot);

	if (Number.isNaN(maybeSpot)) {
		return;
	}

	if (maybeSpot < 1 || maybeSpot > 20) {
		return;
	}

	return maybeSpot;
};
